<template>
  <div v-if="!isDetail">
    <Header :title="`${isEdit == true ? '编辑' : '新增'}分账账户`" @back="onBack"></Header>
    <a-form disable style="margin-top: 30px;" ref="formRef" scrollToFirstError name="form" :labelCol="{span: 6, xxl: 5}"
            :wrapperCol="{span: 14, xxl: 13 }"  @finish="onSubmit" :model="formState">

      <a-form-item label="渠道类型" name="channelType" :rules="[{required: true, message: '必选项不允许为空'}]" @change="onChannelTypeChange">
        <a-radio-group v-model:value="formState.channelType" button-style="solid" :disabled="id">
          <a-radio-button :value="'HUIFU'">汇付</a-radio-button>
          <a-radio-button :value="'ALLINPAY'">通联</a-radio-button>
        </a-radio-group>
      </a-form-item>

      <!-- 汇付账号信息 start -->
      <template v-if="formState.channelType == 'HUIFU'">
        <a-form-item label="账号名称" name="accountName" :rules="[{required: true, message: '必填项不允许为空'}]">
          <a-input v-model:value="formState.accountName" placeholder="请输入账号名称"></a-input>
        </a-form-item>

        <a-form-item label="账号编号" name="accountNo" :rules="[{required: true, message: '必填项不允许为空'}]" extra="建议输入账号名称的英文拼音">
          <a-input v-model:value="formState.accountNo" placeholder="请输入"></a-input>
        </a-form-item>

        <a-form-item label="appId" name="appId" :rules="[{required: true, message: '必填项不允许为空'}]">
          <a-input v-model:value="formState.appId" placeholder="请输入appId"></a-input>
        </a-form-item>

        <a-form-item label="prod模式API_KEY" name="prodApiKey" :rules="[{required: true, message: '必填项不允许为空'}]">
          <a-input v-model:value="formState.prodApiKey" placeholder="请输入prod模式API_KEY"></a-input>
        </a-form-item>

        <a-form-item label="mock模式API_KEY" name="mockApiKey" :rules="[{required: true, message: '必填项不允许为空'}]">
          <a-input v-model:value="formState.mockApiKey" placeholder="请输入mock模式API_KEY"></a-input>
        </a-form-item>

        <a-form-item label="公钥" name="publicKey" :rules="[{required: true, message: '必填项不允许为空'}]">
          <a-input v-model:value="formState.publicKey" placeholder="请输入公钥"></a-input>
        </a-form-item>

        <a-form-item label="私钥" name="privateKey" :rules="[{required: true, message: '必填项不允许为空'}]">
          <a-input v-model:value="formState.privateKey" placeholder="请输入私钥"></a-input>
        </a-form-item>
      </template>
      <!-- 汇付账号信息 end -->

      <!--通联账号信息 start -->
      <template v-if="formState.channelType == 'ALLINPAY'">
        <a-form-item label="账号编号" name="accountNo" :rules="[{required: true, message: '必填项不允许为空'}]" extra="建议输入影院的英文拼音">
          <a-input v-model:value="formState.accountNo" placeholder="请输入"></a-input>
        </a-form-item>

        <a-form-item label="商户号(cusid)" name="accountName" :rules="[{required: true, message: '必填项不允许为空'}]">
          <a-input v-model:value="formState.accountName" placeholder="请输入商户号"></a-input>
        </a-form-item>

        <!-- 用 prodApiKey -->
        <a-form-item label="机构号(orgid)" name="prodApiKey">
          <a-input v-model:value="formState.prodApiKey" placeholder="请输入机构号"></a-input>
        </a-form-item>

        <a-form-item label="应用ID(appId)" name="appId" :rules="[{required: true, message: '必填项不允许为空'}]">
          <a-input v-model:value="formState.appId" placeholder="请输入应用ID(appId)"></a-input>
        </a-form-item>

        <a-form-item label="RSA通联公钥" name="publicKey" :rules="[{required: true, message: '必填项不允许为空'}]" extra="通联提供, RSA通联公钥">
          <a-input v-model:value="formState.publicKey" placeholder="请输入公钥"></a-input>
        </a-form-item>

        <a-form-item label="RSA私钥(JAVA)" name="privateKey" :rules="[{required: true, message: '必填项不允许为空'}]" extra="通联提供, RSA私钥(PKCS8格式，JAVA适用)">
          <a-input v-model:value="formState.privateKey" placeholder="请输入RSA私钥"></a-input>
        </a-form-item>

        <!-- version 用extra_info.version 字段 记录 -->
        <a-form-item label="version" name="version" :rules="[{required: true, message: '必填项不允许为空'}]" extra="默认12">
          <a-input v-model:value="formState.version" placeholder="请输入version"></a-input>
        </a-form-item>

        <a-form-item label="MD5" name="MD5" :rules="[{required: true, message: '必填项不允许为空'}]" extra="通联提供, MD5">
          <a-input v-model:value="formState.MD5" placeholder="请输入MD5"></a-input>
        </a-form-item>

      </template>
      <!--通联账号信息 end -->

      <a-form-item label="备注" name="remark">
        <a-input v-model:value="formState.remark" placeholder="请输入备注"></a-input>
      </a-form-item>

      <a-row>
        <a-col :span="24" style="margin-top: 20px;text-align: center;">
          <a-button type="primary" html-type="submit">提交</a-button>
          <a-button style="margin-left: 20px;" @click="onBack">返回</a-button>
        </a-col>
      </a-row>
    </a-form>
  </div>
<!--  <Detail v-else :id="id" @back="onBack"></Detail>-->
</template>

<script>
  import Header from '@/components/header/header.vue';
  import { Icon } from '@/components/icon/icon.js';
  import { createVNode } from 'vue';
  import { CheckCircleOutlined} from '@ant-design/icons-vue';
  import {
    savePaymentAccount,
    updatePaymentAccount,
  } from '@/service/modules/ledger.js';
  export default {
    components: { Header, Icon  },
    props: {
      isEdit: {
        type: Boolean,
        default: true
      },
      id: {
        type: Number,
        default: 0,
        immedate: true
      },
      isDetail: {
        type: Boolean,
        default: true
      },
    },
    created() {},
    watch: {},
    data() {
      return {
        formState: {
          channelType: 'HUIFU',
        },
      }
    },
    methods: {
      onBack() {
        this.$emit('back');
      },
      onSubmit() {
        this.$refs.formRef.validateFields().then(async () => {
          const postData = JSON.parse(JSON.stringify(this.formState));
          if (this.formState.channelType == 'ALLINPAY') {
            postData.extraInfo = {
              version: this.formState.version,
              MD5: this.formState.MD5
            };
          }
          delete postData.version;
          delete postData.MD5;
          this.loading = true;
          try {
            let res;
            if (this.id) {
              postData.id = this.id;
              res = await updatePaymentAccount(postData);
            } else {
              res = await savePaymentAccount(postData);
            }
            this.loading = false;
            if (res.code == 200) {
              if (this.formState.channelType == 'ALLINPAY') {
                this.$confirm({
                  title: '新增分账账户成功',
                  cancelButtonProps: {
                    style: { display: 'none' }
                  },
                  icon: createVNode(CheckCircleOutlined),
                  onOk: () => {
                    this.onBack(true);
                  },
                })
              } else {
                this.$confirm({
                  title: '新增分账账户成功',
                  content: `该分账账号已同步新增默认分账组，请在分账组配置中查看并管理`,
                  cancelButtonProps: {
                    style: { display: 'none' }
                  },
                  icon: createVNode(CheckCircleOutlined),
                  onOk: () => {
                    this.onBack(true);
                  },
                });
              }
            }
          } catch (error) {
            this.loading = false;
          }
        })
      },
      onChannelTypeChange(e) {
        // console.log(e.target.value)
        this.formState.accountName = '';
        this.formState.accountNo = '';
        this.formState.appId = '';
        this.formState.prodApiKey = '';
        this.formState.mockApiKey = '';
        this.formState.publicKey = '';
        this.formState.privateKey = '';
        this.formState.version = '';
        this.formState.MD5 = '';
        if (e.target.value == 'ALLINPAY') {
          this.formState.version = 12;
        }
      },
    }
  }
</script>

<style scoped>
  .ui-custom__btnInput {
    position: relative;
  }
  .ui-custom__btn {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 9;
  }
  .ui-tip{
    color: #ff0000;
  }
</style>
